module.exports = __webpack_public_path__ + "static/img/17017B_2_3_R_20200710_fit.c64aae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17017B_2_3_R_20200710_fit.png
// module id = qM4o
// module chunks = 0